import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import InputField from '../../../../lego/InputField';
import s from './LargeInputField.scss';
const LargeInputField = (_param)=>{
    var { isPostfixed, className } = _param, rest = _object_without_properties(_param, [
        "isPostfixed",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(InputField, _object_spread({
        className: c(s['root'], isPostfixed && s['postfixed'], className)
    }, rest));
};
LargeInputField.displayName = 'LargeInputField';
export default LargeInputField;

//# sourceMappingURL=LargeInputField.js.map